import React, { createContext } from "react";

export const DashBoardContext = createContext({});
export const DashBoardContextProvider = ({ children }) => {
  const providerValue = {};
  return (
    <DashBoardContext.Provider value={providerValue}>
      {children}
    </DashBoardContext.Provider>
  );
};
